import { Field } from "react-final-form";
import TextFieldAdapter from "@soqs/common/dist/Components/Adapters/TextFieldAdapter";

export interface InputFieldProps {
  required: boolean;
  label: string;
  name: string;
  id?: string;
  maxLength?: number;
  minLength?: number;
  regex?: string;
  taxPractitionerNumberCheck?: boolean;
}

const InputFieldComponent = (props: InputFieldProps) => {
  let { required, label, name, maxLength } = props;

  const isValid = (isRequired: boolean) => (value: any) => {
    if(!isRequired && (!value || value === "")) return undefined;
    if(isRequired && (!value || value === "")) return `Please enter a valid ${props.label}`;
    if(props.regex && value && value !== "") {
        let re = new RegExp(props.regex);
        if(props.taxPractitionerNumberCheck) {
          maxLength = value.includes('-') ? 10 : 9;
          re = new RegExp(`^(PR|pr|Pr|pR)[0-9\w-]{1,${maxLength === 10 ? '8' : '7'}}$`)
        }
        return re.test(value.trim())
      ? undefined
      : `Please enter a valid ${props.label}`;
    }
    return undefined;
  };

  const stripSpaces = (value: string) => {
    return value ? value?.trim() : "";
  };

  return (
    <Field
      required={required}
      label={label}
      name={name}
      fullWidth
      key={required ? name + '-required' : name + '-not-required'}
      validate={isValid(required)}
      component={TextFieldAdapter}
      subscription={{ touched: true, value: true, error: true }}
      inputProps={{ maxLength: maxLength ?? 250, minLength: props.minLength ?? 0 }}
      id={props.id ?? props.name}
      parse={stripSpaces}
    />
  );
};

export default InputFieldComponent;
